// extracted by mini-css-extract-plugin
export var planCard = "_s7-0";
export var planList = "_s7-1";